import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, IAddPassengerUserRequestDto } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class AddPassengerUserCommand extends IRequestCommand<
  IAddPassengerUserResponse,
  ErrorDetails,
  IAddPassengerUserParameters
> {
  public override setParameters(passengerUserParameter: IAddPassengerUserParameters) {
    this._commandType = CommandRequestType.POST;
    this._commandUrl = `passengers${(passengerUserParameter.travelFareId ? '?travelFareId=' + passengerUserParameter.travelFareId.toString() : '')}`;
    this._commandBody = passengerUserParameter;
  }
}

export interface IAddPassengerUserParameters
  extends IAddPassengerUserRequestDto,
    ICommandParameters {
  travelFareId?: number,
}

export interface IAddPassengerUserResponse extends ICommandResponse {}
